import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import ProfileFields from 'forms/client/profile/fields';
import Button from 'forms/shared/buttons';
import validate from './validator'

const ProfileForm = ({ handleSubmit, form, onUpdate, placesOptions = [], processing }) => (
  <form onSubmit={handleSubmit(values => onUpdate(values))}>
    <ProfileFields form={form} placesOptions={placesOptions} />
    <Button
      buttonClassname={`rounded-lg ${processing ? 'bg-form-disabled' : 'bg-primary-orange hover:bg-orange-400'} text-white py-2 px-10`} containerClassname={'text-center pt-5'}>
      {processing ? 'Saving...' : 'Save'}
    </Button>
  </form>
);

ProfileForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  form: PropTypes.string,
  onUpdate: PropTypes.func,
  placesOptions: PropTypes.array,
  processing: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'client-profile-form',
  enableReinitialize: true,
  validate,
})(ProfileForm);
